// extracted by mini-css-extract-plugin
export default {"activity":"styles_activity__rqWkq"};